import React from 'react';
import { componentService } from 'js/services/component.service';

export const CasinoLeaderBoardDetails = React.lazy(() => import(/* webpackChunkName: "casino-leaderboard" */ './Details'));
export const CasinoLeaderBoardList = React.lazy(() => import(/* webpackChunkName: "casino-leaderboard" */ './RacesList'));
export const CasinoLeaderBoardSlider = React.lazy(() => import(/* webpackChunkName: "casino-leaderboard" */ './Slider'));

componentService.registerPageComponents({
    'casino-races-list': CasinoLeaderBoardList,
    'casino-leaderboard-page': CasinoLeaderBoardDetails,
    'casino-leaderboardslider': CasinoLeaderBoardSlider
});
